/**
 * Utility function to safely extract error message from API responses
 * Handles both string and Pydantic validation error array formats
 * 
 * @param {Error} error - Axios error object
 * @param {string} defaultMessage - Default message if error extraction fails
 * @returns {string} Human-readable error message
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || defaultMessage;
  }
  
  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an array (Pydantic validation errors), extract the first message
  if (Array.isArray(detail) && detail.length > 0) {
    const firstError = detail[0];
    // Pydantic v2 format: {type, loc, msg, input, ctx}
    if (firstError?.msg) {
      return firstError.msg;
    }
    // Alternative format
    if (firstError?.message) {
      return firstError.message;
    }
    // If it's a string in the array
    if (typeof firstError === 'string') {
      return firstError;
    }
  }
  
  // If detail is an object with a message property
  if (typeof detail === 'object' && detail?.message) {
    return detail.message;
  }
  
  return defaultMessage;
};

export default getErrorMessage;
